// Constants / utils
import { convertModulesToSaveState } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/utils/custom-pdf-report-builder-utils';
import { EFFICIENT_FRONTIER_MODULE_TYPES, FIELD_TYPES_WITH_RELATED_ITEMS, MODULE_TYPES_WITH_RELATED_ITEMS, PAGE_SIZE_MAX, POSSIBLE_MODULE_SIZES, } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/constants';
import { hasValidReportSecurities } from 'CustomPDFReportsApp/ts/utils/custom-pdf-report-utils';
// NgRx Selectors
import { createDeepEqualSelector } from 'NewAngular/state/selectors';
const getReportType = (state) => (state && state.report_type) || null;
const getReportOrientation = (state) => (state && state.report_orientation) || null;
const getReportName = (state) => (state && state.name) || '';
const getReportDescription = (state) => (state && state.description) || '';
const getReportFooter = (state) => (state && state.report_footer) || null;
const getReportModules = (state) => (state && state.modules) || [];
const getDataSource = (state) => (state && state.data_source) || '';
const getIncludeBenchmarkDefault = (state) => (state && state.include_benchmark_default) || false;
export const getAllowedModuleSizesByPage = createDeepEqualSelector(getReportModules, (modules) => {
    const allowedModuleSizesByPage = {};
    modules.forEach((page, pageNum) => {
        const remainingSpace = PAGE_SIZE_MAX -
            page.reduce((acc, module) => {
                return acc + module.module_size;
            }, 0);
        allowedModuleSizesByPage[pageNum] = POSSIBLE_MODULE_SIZES.filter((size) => size <= remainingSpace);
    });
    return allowedModuleSizesByPage;
});
export const hasEfficientFrontierModules = createDeepEqualSelector(getReportModules, (modules) => {
    return modules.some((page, _) => page.some((module) => EFFICIENT_FRONTIER_MODULE_TYPES.includes(module.module_type)));
});
const getAdvancedOptions = (state) => state.advanced_options;
export const getCustomPDFReportSaveParams = createDeepEqualSelector(getReportType, getReportOrientation, getReportName, getReportDescription, getReportFooter, getReportModules, getIncludeBenchmarkDefault, getAdvancedOptions, getDataSource, (report_type, report_orientation, name, description, report_footer, modules, include_benchmark_default, advanced_options, data_source) => {
    return {
        report_type,
        report_orientation,
        name,
        description,
        report_footer,
        modules: convertModulesToSaveState(modules),
        include_benchmark_default,
        advanced_options,
        data_source,
    };
});
export const canSave = createDeepEqualSelector(getReportType, getReportModules, (reportType, modules) => {
    // Must have selected a report type and have at least one module on the report in order to save it
    return !!reportType && modules.some((page) => page.length);
});
export const getWarningMessage = createDeepEqualSelector(getReportModules, (modules) => {
    const pagesMissingInput = [];
    modules.forEach((page, pageNum) => {
        page.forEach((module) => {
            if (MODULE_TYPES_WITH_RELATED_ITEMS.has(module.module_type) &&
                !Object.values(module.customizable_fields).some((field) => FIELD_TYPES_WITH_RELATED_ITEMS.has(field.type) && field.value)) {
                pagesMissingInput.push(pageNum + 1);
            }
        });
    });
    let warningMessage = '';
    if (pagesMissingInput.length) {
        if (pagesMissingInput.length === 1) {
            warningMessage = `Page ${pagesMissingInput[0]} has a module with no attachment/security. This page will be blank when the report is generated.`;
        }
        else if (pagesMissingInput.length === 2) {
            warningMessage = `Pages ${pagesMissingInput[0]} and ${pagesMissingInput[1]} have a module with no attachment/security. These pages will be blank when the report is generated.`;
        }
        else {
            warningMessage = `Pages ${pagesMissingInput.slice(0, pagesMissingInput.length - 1).join(', ')}, and ${pagesMissingInput[pagesMissingInput.length - 1]} have a module with no attachment/security. These pages will be blank when the report is generated.`;
        }
    }
    return warningMessage;
});
const getPreviewSecurities = (state) => state.preview_securities;
export const hasValidPreviewSecurities = createDeepEqualSelector(getReportType, getPreviewSecurities, (reportType, previewSecurities) => {
    return hasValidReportSecurities(reportType, previewSecurities.primary, previewSecurities.secondary, previewSecurities.comparison);
});
